import { render, staticRenderFns } from "./FilePreviewModal.vue?vue&type=template&id=1ce3960a&scoped=true&"
import script from "./FilePreviewModal.vue?vue&type=script&lang=ts&"
export * from "./FilePreviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./FilePreviewModal.vue?vue&type=style&index=0&id=1ce3960a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3960a",
  null
  
)

export default component.exports